import { createFileRoute } from "@tanstack/react-router";
import { UserProfile } from "@/features/user-profile/components/UserProfile";
import { isSafeInternalPath } from "@/lib/navigation/userProfileNavigation";

type UserProfileSearch = {
  from?: string;
};

export const Route = createFileRoute("/user-profile/$user-id")({
  component: UserProfile,
  validateSearch: (search: Record<string, unknown>): UserProfileSearch => ({
    from: isSafeInternalPath(search.from) ? search.from : undefined,
  }),
});
